export default "__VITE_ASSET__bDoB4_56__"